
import { CameraGroup } from '@/api';
import { Options, Prop, Vue } from 'vue-property-decorator';
import VideoWallCameraListGroup from './VideoWallCameraListGroup.vue';

@Options({
  components: { VideoWallCameraListGroup }
})
export default class VideoWallCameraList extends Vue {
  @Prop({ required: true, type: Array })
  readonly groups!: CameraGroup[];
}
